export enum PickerType {
    DAY,
    MONTH,
    YEAR,
}
